export const cssBundleHref = "/build/css-bundle-JSNZLZOC.css";